import { render, staticRenderFns } from "./DiaMesChart.vue?vue&type=template&id=38cde39c"
import script from "./DiaMesChart.vue?vue&type=script&lang=js"
export * from "./DiaMesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports